import React, { useEffect, useMemo } from 'react';
import MobileLandingPageVertical from './MobileLandingPageVertical';
import MobileLandingPageSnapboard from './MobileLandingPageSnapboard';
import { trackEvent } from '../../../utils/analytics';

// Root Mobile Landing Page with feature flag routing
// Default: Vertical scroll layout
// Fallback: Snapboard layout via ?layout=snapboard query param
export default function MobileLandingPage(){
  // Parse layout query param
  const layout = useMemo(() => {
    if (typeof window === 'undefined') return 'vertical';
    const params = new URLSearchParams(window.location.search);
    const layoutParam = params.get('layout');
    return layoutParam === 'snapboard' ? 'snapboard' : 'vertical';
  }, []);

  // Track which variant is being shown
  useEffect(() => {
    trackEvent('page_view', {
      page_name: 'mobile_landing',
      hero_variant: layout
    });
  }, [layout]);

  // Render appropriate version based on layout flag
  if (layout === 'snapboard') {
    return <MobileLandingPageSnapboard />;
  }
  
  return <MobileLandingPageVertical />;
}
